import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const PRINCIPLES: ReadonlyArray<
	Readonly<{ id: string; numeral: TranslationKey; title: TranslationKey; body: TranslationKey }>
> = [
	{
		id: 'voice',
		numeral: translationKey('corgi.vision_page.principles.voice.numeral'),
		title: translationKey('corgi.vision_page.principles.voice.title'),
		body: translationKey('corgi.vision_page.principles.voice.body'),
	},
	{
		id: 'local',
		numeral: translationKey('corgi.vision_page.principles.local.numeral'),
		title: translationKey('corgi.vision_page.principles.local.title'),
		body: translationKey('corgi.vision_page.principles.local.body'),
	},
];
